module.exports = __webpack_public_path__ + "static/img/20151.6d8532c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/20151.jpg
// module id = fhC9
// module chunks = 1